import { render, staticRenderFns } from "./ControlPanel.vue?vue&type=template&id=480f6be6"
import script from "./ControlPanel.vue?vue&type=script&lang=ts"
export * from "./ControlPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports